import { useEffect } from 'react';
import styled from 'styled-components';

import { Button, Modal, ModalProps } from '@gif/shared-ui';
import { noop } from '@gif/shared-global';

import { useAdobeTracking } from '../../../hooks';
import { translate } from '../../../configs';

export interface AgeGateModalProps extends ModalProps {
  title?: string;
  body?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const DEFAULT_TITLE = translate('doNotMeetAgeRequirements');
const DEFAULT_BUTTON_TEXT = translate('returnToMLBPlay');

const ModalContainer = styled(Modal)`
  background-color: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.fontColor};
`;

const Title = styled.h2`
  margin: 0.5rem 0 0 0;
  font-size: 1.19rem;
  font-weight: 600;
  line-height: 120%;
  text-align: center;
`;

const Body = styled.p`
  font-size: 1rem;
  font-weight: 400;
  line-height: 150%;
`;

const StyledButton = styled(Button)`
  width: 100%;
  &:focus-visible,
  button:focus-visible {
    outline: revert;
    border: white solid 0.25rem;
  }
`;

export const AgeGateModal = ({
  title = DEFAULT_TITLE,
  body = DEFAULT_TITLE,
  buttonText = DEFAULT_BUTTON_TEXT,
  onButtonClick = noop,
  ...rest
}: AgeGateModalProps) => {
  // Analytics Page Tracking
  const { trackPageView } = useAdobeTracking();
  useEffect(() => {
    if (rest.isOpen) {
      trackPageView({
        type: 'Gaming Hub',
        subType: 'Age Gate Modal',
      });
    }
  }, [rest.isOpen, trackPageView]);
  // End Analytics Page Tracking

  return (
    <ModalContainer {...rest}>
      <Title>{title}</Title>
      <Body>{body}</Body>
      <StyledButton onClick={onButtonClick}>{buttonText}</StyledButton>
    </ModalContainer>
  );
};

export default AgeGateModal;
